/* Pakistan Furniture Wave 2 accessibility enhancements. */
(function () {
  'use strict';

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function syncRadioGroup(group) {
    if (!group) return;
    var items = Array.prototype.slice.call(group.querySelectorAll('[data-swatch-item][role="radio"]'));
    if (!items.length) return;

    var selected = null;
    items.forEach(function (item) {
      if (item.classList.contains('is--selected')) selected = item;
    });
    selected = selected || items[0];

    items.forEach(function (item) {
      var isSelected = item === selected;
      item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      item.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  }

  function syncAllRadioGroups(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[role="radiogroup"]').forEach(syncRadioGroup);
    if (root && root.matches && root.matches('[role="radiogroup"]')) syncRadioGroup(root);
  }

  var activeProductDropdown = null;
  var productDropdownTypeahead = '';
  var productDropdownTypeaheadTimer = 0;

  function productDropdownWrapper(trigger) {
    if (!trigger) return null;
    var sibling = trigger.nextElementSibling;
    if (sibling && sibling.matches && sibling.matches('[data-dropdown-wrapper]')) return sibling;
    var wrapperId = trigger.getAttribute('data-id');
    return wrapperId ? document.getElementById(wrapperId) : null;
  }

  function productDropdownListbox(trigger) {
    if (!trigger) return null;
    var listboxId = trigger.getAttribute('aria-controls');
    return listboxId ? document.getElementById(listboxId) : null;
  }

  function productDropdownTriggerForWrapper(wrapper) {
    if (!wrapper || !wrapper.id) return null;
    var scope = wrapper.parentElement || document;
    var triggers = Array.prototype.slice.call(scope.querySelectorAll('[data-dropdown-open][aria-haspopup="listbox"]'));
    return triggers.filter(function (trigger) { return productDropdownWrapper(trigger) === wrapper; })[0] || null;
  }

  function currentProductDropdownTrigger(controlId, fallback) {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown-open][aria-haspopup="listbox"]'));
    return triggers.filter(function (trigger) { return trigger.getAttribute('aria-controls') === controlId; })[0] || fallback;
  }

  function productDropdownTriggerFromElement(element) {
    return productDropdownTriggerForWrapper(closest(element, '[data-dropdown-wrapper]'));
  }

  function productDropdownOptions(trigger) {
    var listbox = productDropdownListbox(trigger);
    return listbox ? Array.prototype.slice.call(listbox.querySelectorAll('[data-swatch-item][role="option"]')) : [];
  }

  function productDropdownIsOpen(trigger) {
    var wrapper = productDropdownWrapper(trigger);
    return !!(wrapper && wrapper.classList.contains('is--opened'));
  }

  function syncProductDropdown(trigger) {
    var options = productDropdownOptions(trigger);
    if (!trigger || !options.length) return;

    var selected = options.filter(function (option) { return option.classList.contains('is--selected'); })[0] || options[0];
    options.forEach(function (option) {
      option.setAttribute('aria-selected', option === selected ? 'true' : 'false');
      option.setAttribute('tabindex', '-1');
    });
  }

  function setProductDropdownExpanded(trigger, expanded) {
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      if (activeProductDropdown && activeProductDropdown !== trigger) {
        activeProductDropdown.setAttribute('aria-expanded', 'false');
      }
      activeProductDropdown = trigger;
    } else if (activeProductDropdown === trigger) {
      activeProductDropdown = null;
    }
  }

  function focusProductDropdownOption(trigger, edge) {
    if (!trigger || trigger.getAttribute('aria-expanded') !== 'true') return;
    var options = productDropdownOptions(trigger);
    if (!options.length) return;
    var selected = options.filter(function (option) { return option.getAttribute('aria-selected') === 'true'; })[0];
    var target = edge === 'last' ? options[options.length - 1] : (selected || options[0]);
    target.focus();
  }

  function closeProductDropdown(trigger, returnFocus) {
    if (!trigger) return;
    var wrapper = productDropdownWrapper(trigger);
    var closeButton = wrapper && wrapper.querySelector('[data-dropdown-close]');
    var controlId = trigger.getAttribute('aria-controls');
    setProductDropdownExpanded(trigger, false);
    if (closeButton) closeButton.click();
    if (returnFocus) {
      window.setTimeout(function () {
        var currentTrigger = currentProductDropdownTrigger(controlId, trigger);
        if (currentTrigger && document.contains(currentTrigger)) currentTrigger.focus();
      }, 0);
    }
  }

  function adjacentProductControl(trigger, backwards) {
    var wrapper = productDropdownWrapper(trigger);
    var selector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var focusables = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (element) {
      return element.getClientRects().length > 0 && !closest(element, '[aria-hidden="true"]') && (!wrapper || !wrapper.contains(element));
    });
    var index = focusables.indexOf(trigger);
    if (index === -1) return trigger;
    return focusables[index + (backwards ? -1 : 1)] || trigger;
  }

  function enhanceProductDropdowns(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var triggers = Array.prototype.slice.call(scope.querySelectorAll('[data-dropdown-open][aria-haspopup="listbox"]'));
    if (root && root.matches && root.matches('[data-dropdown-open][aria-haspopup="listbox"]')) triggers.push(root);

    triggers.forEach(function (trigger) {
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      syncProductDropdown(trigger);
    });
  }

  function enhanceWhatsApp(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var triggers = Array.prototype.slice.call(scope.querySelectorAll('#wa .wa__btn_popup'));
    if (root && root.matches && root.matches('#wa .wa__btn_popup')) triggers.push(root);

    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-pfi-a11y-ready') === 'true') return;
      trigger.setAttribute('data-pfi-a11y-ready', 'true');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', 'Open WhatsApp support');
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    });
  }

  var drawerIds = ['t4s-menu-drawer', 't4s-search-hidden', 't4s-mini_cart'];
  var activeDrawer = null;
  var drawerOpener = null;

  function drawerIdFromTrigger(trigger) {
    if (!trigger) return null;
    var controlled = trigger.getAttribute('aria-controls');
    if (controlled && drawerIds.indexOf(controlled) !== -1) return controlled;
    var options = trigger.getAttribute('data-drawer-options') || '';
    var match = options.match(/#([A-Za-z0-9_-]+)/);
    return match && drawerIds.indexOf(match[1]) !== -1 ? match[1] : null;
  }

  function enhanceDrawerTriggers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var triggers = Array.prototype.slice.call(scope.querySelectorAll('[data-drawer-options], [data-menu-drawer]'));
    if (root && root.matches && root.matches('[data-drawer-options], [data-menu-drawer]')) triggers.push(root);

    triggers.forEach(function (trigger) {
      var drawerId = drawerIdFromTrigger(trigger);
      if (!drawerId) return;
      trigger.setAttribute('aria-controls', drawerId);
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function enhanceDrawers(root) {
    drawerIds.forEach(function (id) {
      var drawer = (root && root.id === id) ? root : document.getElementById(id);
      if (!drawer) return;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('tabindex', '-1');
      if (!drawer.hasAttribute('aria-label')) {
        drawer.setAttribute('aria-label', id === 't4s-menu-drawer' ? 'Navigation menu' : (id === 't4s-search-hidden' ? 'Search' : 'Shopping cart'));
      }
    });
  }

  function enhanceSearchDrawer() {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;

    var input = drawer.querySelector('[data-input-search]');
    if (!input) return;
    var firstPass = input.getAttribute('data-pfi-a11y-ready') !== 'true';

    input.setAttribute('data-pfi-a11y-ready', 'true');
    input.setAttribute('aria-label', 'Search products');

    var category = drawer.querySelector('[data-name="product_type"], select');
    if (category) category.setAttribute('aria-label', 'Product category');

    var submit = drawer.querySelector('[data-submit-search], .t4s-mini-search__submit');
    if (submit) submit.setAttribute('aria-label', 'Submit search');

    if (firstPass && isDrawerOpen(drawer)) {
      window.setTimeout(function () { input.focus(); }, 0);
    }
  }

  function isDrawerOpen(drawer) {
    return !!drawer && (drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('is--opened'));
  }

  function visibleFocusables(drawer) {
    var selector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var focusables = Array.prototype.slice.call(drawer.querySelectorAll(selector)).filter(function (element) {
      return element.getClientRects().length > 0 && !closest(element, '[aria-hidden="true"]');
    });

    if (drawer.id === 't4s-menu-drawer') {
      var externalClose = document.getElementById('pfi-menu-close');
      if (externalClose && externalClose.getClientRects().length > 0 && focusables.indexOf(externalClose) === -1) {
        focusables.push(externalClose);
      }
    }

    return focusables;
  }

  function focusDrawer(drawer) {
    if (!drawer || activeDrawer !== drawer) return;
    var focusables = visibleFocusables(drawer);
    var preferred = drawer.id === 't4s-search-hidden'
      ? focusables.filter(function (element) { return element.matches('[data-input-search]'); })[0]
      : focusables[0];
    (preferred || drawer).focus();
  }

  function setPageInert(value) {
    var wrapper = document.querySelector('.t4s-website-wrapper');
    if (wrapper && 'inert' in wrapper) wrapper.inert = value;
  }

  function syncDrawers() {
    enhanceDrawers(document);
    enhanceDrawerTriggers(document);
    enhanceSearchDrawer();

    var openDrawer = null;
    drawerIds.some(function (id) {
      var drawer = document.getElementById(id);
      if (isDrawerOpen(drawer)) {
        openDrawer = drawer;
        return true;
      }
      return false;
    });

    drawerIds.forEach(function (id) {
      var expanded = !!openDrawer && openDrawer.id === id;
      document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    if (openDrawer && activeDrawer !== openDrawer) {
      activeDrawer = openDrawer;
      if (!drawerOpener || closest(drawerOpener, '[aria-hidden="true"]')) drawerOpener = document.activeElement;
      setPageInert(true);
      window.setTimeout(function () { focusDrawer(openDrawer); }, 0);
      window.setTimeout(function () { focusDrawer(openDrawer); }, 250);
      return;
    }

    if (!openDrawer && activeDrawer) {
      activeDrawer = null;
      setPageInert(false);
      if (drawerOpener && document.contains(drawerOpener)) drawerOpener.focus();
      drawerOpener = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, '[data-drawer-options], [data-menu-drawer]');
    if (drawerIdFromTrigger(trigger)) drawerOpener = trigger;
  }, true);

  document.addEventListener('keydown', function (event) {
    var trigger = closest(event.target, '[data-drawer-options], [data-menu-drawer]');
    if (trigger && drawerIdFromTrigger(trigger) && event.key === ' ') {
      event.preventDefault();
      drawerOpener = trigger;
      trigger.click();
      return;
    }

    if (!activeDrawer) return;
    if (event.key === 'Escape') {
      var closeButton = activeDrawer.querySelector('[data-drawer-close]');
      if (!closeButton && activeDrawer.id === 't4s-menu-drawer') closeButton = document.getElementById('pfi-menu-close');
      if (closeButton) {
        event.preventDefault();
        closeButton.click();
      }
      return;
    }

    if (event.key !== 'Tab') return;
    var focusables = visibleFocusables(activeDrawer);
    if (!focusables.length) {
      event.preventDefault();
      activeDrawer.focus();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (document.activeElement === activeDrawer || focusables.indexOf(document.activeElement) === -1) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    var item = closest(event.target, '[data-swatch-item][role="radio"]');
    if (!item) return;

    var group = closest(item, '[role="radiogroup"]');
    if (!group) return;
    var items = Array.prototype.slice.call(group.querySelectorAll('[data-swatch-item][role="radio"]'));
    var currentIndex = items.indexOf(item);
    var nextIndex = currentIndex;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % items.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + items.length) % items.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = items.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    items[nextIndex].focus();
    items[nextIndex].click();
    window.setTimeout(function () { syncRadioGroup(group); }, 0);
  });

  document.addEventListener('click', function (event) {
    var item = closest(event.target, '[data-swatch-item][role="radio"]');
    if (!item) return;
    window.setTimeout(function () { syncRadioGroup(closest(item, '[role="radiogroup"]')); }, 0);
  });

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, '[data-dropdown-open][aria-haspopup="listbox"]');
    if (trigger) {
      var opening = !productDropdownIsOpen(trigger);
      setProductDropdownExpanded(trigger, opening);
      if (opening) {
        window.setTimeout(function () { focusProductDropdownOption(trigger); }, 0);
        window.setTimeout(function () { focusProductDropdownOption(trigger); }, 180);
        window.setTimeout(function () { focusProductDropdownOption(trigger); }, 420);
        window.setTimeout(function () { focusProductDropdownOption(trigger); }, 700);
      }
      return;
    }

    var option = closest(event.target, '[data-dropdown-wrapper] [data-swatch-item][role="option"]');
    if (option) {
      trigger = productDropdownTriggerFromElement(option);
      if (!trigger) return;
      var controlId = trigger.getAttribute('aria-controls');
      window.setTimeout(function () {
        var currentTrigger = currentProductDropdownTrigger(controlId, trigger);
        syncProductDropdown(currentTrigger);
        setProductDropdownExpanded(currentTrigger, false);
        if (currentTrigger && document.contains(currentTrigger)) currentTrigger.focus();
      }, 0);
      return;
    }

    var closeButton = closest(event.target, '[data-dropdown-wrapper] [data-dropdown-close]');
    if (closeButton) {
      trigger = productDropdownTriggerFromElement(closeButton);
      if (trigger) {
        setProductDropdownExpanded(trigger, false);
        window.setTimeout(function () {
          if (document.contains(trigger)) trigger.focus();
        }, 0);
      }
      return;
    }

    if (activeProductDropdown) {
      var wrapper = productDropdownWrapper(activeProductDropdown);
      if (!wrapper || !wrapper.contains(event.target)) setProductDropdownExpanded(activeProductDropdown, false);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var trigger = closest(event.target, '[data-dropdown-open][aria-haspopup="listbox"]');
    if (trigger) {
      var triggerOpen = productDropdownIsOpen(trigger) && trigger.getAttribute('aria-expanded') === 'true';
      var triggerOptions = productDropdownOptions(trigger);

      if (triggerOpen && triggerOptions.length && (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'Home' || event.key === 'End')) {
        event.preventDefault();
        var triggerSelected = triggerOptions.filter(function (item) { return item.getAttribute('aria-selected') === 'true'; })[0] || triggerOptions[0];
        var triggerIndex = Math.max(0, triggerOptions.indexOf(triggerSelected));
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') triggerIndex = (triggerIndex + 1) % triggerOptions.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') triggerIndex = (triggerIndex - 1 + triggerOptions.length) % triggerOptions.length;
        if (event.key === 'Home') triggerIndex = 0;
        if (event.key === 'End') triggerIndex = triggerOptions.length - 1;
        if (triggerOptions[triggerIndex]) triggerOptions[triggerIndex].focus();
        return;
      }

      if (triggerOpen && event.key === 'Escape') {
        event.preventDefault();
        closeProductDropdown(trigger, true);
        return;
      }

      if (!triggerOpen && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        trigger.click();
        var openingEdge = event.key === 'ArrowUp' ? 'last' : null;
        window.setTimeout(function () { focusProductDropdownOption(trigger, openingEdge); }, 0);
        window.setTimeout(function () { focusProductDropdownOption(trigger, openingEdge); }, 180);
        window.setTimeout(function () { focusProductDropdownOption(trigger, openingEdge); }, 420);
        window.setTimeout(function () { focusProductDropdownOption(trigger, openingEdge); }, 700);
        return;
      }
    }

    var option = closest(event.target, '[data-dropdown-wrapper] [data-swatch-item][role="option"]');
    if (!option) return;
    trigger = productDropdownTriggerFromElement(option);
    if (!trigger) return;
    var options = productDropdownOptions(trigger);
    var currentIndex = options.indexOf(option);
    var nextIndex = currentIndex;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % options.length;
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + options.length) % options.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = options.length - 1;

    if (nextIndex !== currentIndex) {
      event.preventDefault();
      options[nextIndex].focus();
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      option.click();
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeProductDropdown(trigger, true);
      return;
    }

    if (event.key === 'Tab') {
      var adjacent = adjacentProductControl(trigger, event.shiftKey);
      event.preventDefault();
      closeProductDropdown(trigger, false);
      window.setTimeout(function () {
        if (adjacent && document.contains(adjacent)) adjacent.focus();
      }, 0);
      return;
    }

    if (event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey) {
      window.clearTimeout(productDropdownTypeaheadTimer);
      productDropdownTypeahead += event.key.toLocaleLowerCase();
      var query = productDropdownTypeahead;
      var ordered = options.slice(currentIndex + 1).concat(options.slice(0, currentIndex + 1));
      var match = ordered.filter(function (item) {
        return item.textContent.trim().toLocaleLowerCase().indexOf(query) === 0;
      })[0];
      if (match) {
        event.preventDefault();
        match.focus();
      }
      productDropdownTypeaheadTimer = window.setTimeout(function () {
        productDropdownTypeahead = '';
      }, 500);
    }
  });

  function initialize(root, deferDrawerSync) {
    syncAllRadioGroups(root || document);
    enhanceProductDropdowns(root || document);
    enhanceWhatsApp(root || document);
    enhanceDrawerTriggers(root || document);
    enhanceDrawers(root || document);
    enhanceSearchDrawer();
    if (!deferDrawerSync) syncDrawers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  var drawerSyncFrame = 0;

  function scheduleDrawerSync() {
    if (drawerSyncFrame) return;
    drawerSyncFrame = window.requestAnimationFrame(function () {
      drawerSyncFrame = 0;
      syncDrawers();
    });
  }

  var enhancementFrame = 0;
  var pendingEnhancementRoots = [];
  var enhancementSelector = [
    '[role="radiogroup"]',
    '[data-dropdown-open][aria-haspopup="listbox"]',
    '#wa .wa__btn_popup',
    '[data-drawer-options]',
    '[data-menu-drawer]',
    '#t4s-menu-drawer',
    '#t4s-search-hidden',
    '#t4s-mini_cart'
  ].join(', ');

  function rootNeedsEnhancement(node) {
    if (!node || node.nodeType !== 1) return false;
    return (node.matches && node.matches(enhancementSelector)) ||
      (node.querySelector && node.querySelector(enhancementSelector));
  }

  function observeDrawer(drawer) {
    if (!drawer || drawer.getAttribute('data-pfi-drawer-observed') === 'true') return;
    drawer.setAttribute('data-pfi-drawer-observed', 'true');
    var drawerObserver = new MutationObserver(scheduleDrawerSync);
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function observeKnownDrawers(root) {
    drawerIds.forEach(function (id) {
      var drawer = root && root.id === id ? root : document.getElementById(id);
      observeDrawer(drawer);
    });
  }

  function scheduleEnhancement(node) {
    if (!rootNeedsEnhancement(node)) return;
    pendingEnhancementRoots.push(node);
    if (enhancementFrame) return;
    enhancementFrame = window.requestAnimationFrame(function () {
      var roots = pendingEnhancementRoots.slice();
      enhancementFrame = 0;
      pendingEnhancementRoots.length = 0;
      roots.forEach(function (root) {
        if (document.contains(root)) initialize(root, true);
      });
      observeKnownDrawers(document);
      scheduleDrawerSync();
    });
  }

  observeKnownDrawers(document);

  var additionsObserver = new MutationObserver(function (records) {
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, scheduleEnhancement);
    });
  });

  additionsObserver.observe(document.body || document.documentElement, {
    subtree: true,
    childList: true
  });
})();

